import { render, staticRenderFns } from "./comDescPopup.vue?vue&type=template&id=80c43f5a"
import script from "./comDescPopup.vue?vue&type=script&lang=js"
export * from "./comDescPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports